module.exports = __webpack_public_path__ + "static/media/smartmockups2.787bd89f.png";